import React from 'react';
import {
  EntityLabel,
  Card,
  CardMedia,
  CardContent,
  CardFooter,
  Text,
  FormatDate,
  BlockText,
} from '@morressier/ts';
import Link from 'next/link';

type Props = {
  id: string;
  image: string;
  title: string;
  location: string;
  date: string | number;
};

const EventCard = (props: Props) => (
  <Link
    href={{
      pathname: '/event/[eventId]',
      query: { eventId: props.id },
    }}
  >
    <Card distribution="vertical">
      <CardMedia url={props.image} title="" />
      <CardContent>
        <EntityLabel>Conference</EntityLabel>
        <BlockText size="body1_new" color="secondaryBrand">
          <Text fontWeight="bold">{props.title}</Text>
          <Text>{props.location}</Text>

          <FormatDate
            startDate={props.date as string}
            endDate={props.date as string}
            longFormat={false}
            style={{ color: 'inherit' }}
          />
        </BlockText>
      </CardContent>
      <CardFooter>&nbsp;</CardFooter>
    </Card>
  </Link>
);

export default EventCard;
